import React from 'react';
import Button from '@material-ui/core/Button';

import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';

import { useTheme } from '@material-ui/core';
import { UNSAVED_CHANGES_LEAVE_MESSAGE } from '../../../utils/messages';

export default function GoToButton(props) {
  const history = useHistory();
  const theme = useTheme();
  return (
    <Button
      type="button"
      variant="contained"
      size="medium"
      disabled={props.disabled}
      style={{
        color: props.disabled
          ? theme.palette.text.disabled
          : theme.palette.text.main,
        margin: '10px',
        backgroundColor: props.disabled
          ? theme.palette.disabled.main
          : props.grayVersion
            ? theme.palette.secondary.other
            : props.secondaryButton
              ? theme.palette.secondary.main
              : theme.palette.primary.main,
      }}
      onClick={() => {
        if (props.showAlert === true) {
          var r = window.confirm(UNSAVED_CHANGES_LEAVE_MESSAGE);
          if (r === true) {
            history.push(props.path);
          }
        } else {
          history.push(props.path);
        }
      }}
    >
      {props.label}
    </Button>
  );
}

GoToButton.propTypes = {
  showAlert: PropTypes.bool,
  path: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  grayVersion: PropTypes.bool.isRequired,
};
